import React, { useRef, useState, useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { cookie } from 'cookie';
import { RootReducerState } from 'reduxStore/rootReducers';
import { BiSearch } from 'react-icons/bi';
import { IoClose } from 'react-icons/io5';
import { Link, useHistory } from 'react-router-dom';
import { searchContent } from 'reduxStore/actions';
import { getFormData, UrlFirstSegment } from 'utils/global';
import { storage } from 'utils/global';
import { FIRST_VISIT } from 'utils/global/constant';
import { checkLoanEligibilityRequest } from 'reduxStore/actions/loanEligibilityAction';
import { useIntl } from 'react-intl';
import { loadable } from 'react-lazily/loadable';
export const CURRENT_TOP_MENU = 'currentTopMenu';
const { TranslationMessage } = loadable(() => import('components'), {
	fallback: <>Loading...</>,
});
interface Props {
	isSearchActive: boolean;
	toggleNaviagtion: (navigationKey: string) => void;
}

const GlobalSearch = ({ toggleNaviagtion, isSearchActive }: Props) => {
	const params = new URLSearchParams(window.location.search);
	const [searchText, setSearchText] = useState<any>(params.get('search_text') ?? '');
	const dispatch = useDispatch();
	const history = useHistory();
	const urlFirstSegment = UrlFirstSegment();
	const { searchMenuData } = useSelector(
		({ menuReducer, searchContentReducer }: RootReducerState) => ({
			searchMenuData: menuReducer.searchMenuData,
		}),
		shallowEqual
	);
	const intl = useIntl();
	const searchRef = useRef<any>(null);

	const [firstVisit, setFirstVisit] = useState('false');

	const generateLink = (item) => {
		// if (validURL(item.menu_url))
		if (String(item.menu_url).includes('http'))
			return (
				<a href={item.menu_url} target="_blank">
					<TranslationMessage data={item} value="menu_title" />{' '}
				</a>
			);
		else
			return (
				<Link to={item.menu_url}>
					<TranslationMessage data={item} value="menu_title" />
				</Link>
			);
	};

	const handleSearch = (e) => {
		e.preventDefault();
		toggleNaviagtion('searchDropdown');
		if (searchText) {
			dispatch(searchContent(getFormData({ parameter: searchText, section: '' })));
			setSearchText('');
			history.push(`/search?search_text=${searchText}`);
		}
		// else {
		// 	history.push(`/${urlFirstSegment}/search`);
		// }
	};

	// const [itemsLocal, setItemsLocal] = useState([]);

	// useEffect(() => {

	// 	// const FirstVisit = localStorage.setItem('FIRST_VISIT', "yes");
	// 	// const VisVisit = localStorage.getItem('FIRST_VISIT', "yes");
	// 	console.log("yrdy", localStorage.getItem('FIRST_VISIT'));
	// }, [])

	// console.log("FirstVisi", FirstVisit);
	// const FirstVisitLocal = () => {
	// 	if (localStorage.getItem('FIRST_VISIT') == 'yes') {
	// 		console.log("This is running")
	// 	}
	// }
	// console.log(FirstVisitLocal);
	// console.log(localStorage.getItem('FIRST_VISIT'))

	// console.log("test cookie", document.cookie)
	var cookie = require('cookie');
	// var setCookie = cookie.serialize('foo', 'bar');

	let value = window.localStorage.getItem('uniqueFDId');

	// console.log('uuid', cookie.setItem('uniqueFDId', ''));
	// console.log("setCookie", value);
	return (
		<div>
			<button
				className={`btn btn-md text-success py-0 btnSearch ${isSearchActive ? 'btnSearch-active' : ''} `}
				onClick={(e) => {
					if (isSearchActive) {
						handleSearch(e);
					}
					setTimeout(() => {
						searchRef?.current?.focus();
					}, 300);
					toggleNaviagtion('searchDropdown');
				}}
				style={{ fontSize: '24px' }}
			>
				{/* <BiSearch /> */}
				{isSearchActive ? <IoClose /> : <BiSearch />}
			</button>

			{isSearchActive && (
				<div className="search-wrapper">
					<form onSubmit={handleSearch}>
						<div className="search-wrapper-wrap">
							<input
								ref={searchRef}
								type="text"
								placeholder={intl.formatMessage({
									id: 'what-are-you-looking-for',
								})}
								className="search-input"
								onChange={(e) => setSearchText(e.target.value)}
							/>
							{/* <div className="search-wrapper-btnwrap">
								<span>

									Press enter
							</span>
								<AiOutlineEnter />
							</div> */}
						</div>
					</form>
					{/* <div className="search-lists-wrapper">
						<div className="row">
							<div className="col-md-8">
								{isSearchActive && localStorage.getItem('FIRST_VISIT') == 'no' ? (
									<ul className="search-lists">
										<li className="search-list">
											<a href={void 0}>
												<figure className="search-list-img"></figure>
												<div className="search-list-data">
													<h5>Best personal loan rates in kathmandu</h5>
													<h6>A user is about to buy an expensive couch on a website they've never used before.</h6>
												</div>
											</a>
										</li>{' '}
										<li className="search-list">
											<a href={void 0}>
												<figure className="search-list-img"></figure>
												<div className="search-list-data">
													<h5>Best personal loan rates in kathmandu</h5>
													<h6>A user is about to buy an expensive couch on a website they've never used before.</h6>
												</div>
											</a>
										</li>{' '}
										<li className="search-list">
											<a href={void 0}>
												<figure className="search-list-img"></figure>
												<div className="search-list-data">
													<h5>Best personal loan rates in kathmandu</h5>
													<h6>A user is about to buy an expensive couch on a website they've never used before.</h6>
												</div>
											</a>
										</li>{' '}
										<li className="search-list">
											<a href={void 0}>
												<figure className="search-list-img"></figure>
												<div className="search-list-data">
													<h5>Best personal loan rates in kathmandu</h5>
													<h6>A user is about to buy an expensive couch on a website they've never used before.</h6>
												</div>
											</a>
										</li>
									</ul>

								) : (
									<div>THis is the test</div>
								)}
							</div>
							<div className="col-md-4">
								<div className="quick-links-wrapper">
									{searchMenuData.map((searchMenu, smIndex) => (
										<React.Fragment key={smIndex}>
											<h6 className="text-danger font-weight-bold">
												<TranslationMessage data={searchMenu} value="menu_title" />
											</h6>
											<ul className="quick-links-lists list-unstyled">
												{searchMenu.submenu.map((smSubItem, ind) => (
													<li key={ind}>{generateLink(smSubItem)}</li>
												))}
											</ul>
										</React.Fragment>
									))}
								</div>
							</div>
						</div>
					</div> */}
				</div>
			)}
		</div>
	);
};

export default GlobalSearch;
